import { render, staticRenderFns } from "./avalonLineSettings.vue?vue&type=template&id=5c231988&scoped=true&"
import script from "./avalonLineSettings.vue?vue&type=script&lang=js&"
export * from "./avalonLineSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c231988",
  null
  
)

export default component.exports